<template>
    <div class="artButtons">
        <a href="#/snow">
            <span style="background-color: #2c3e50; color: white">Snow</span>
        </a>
        <a href="#/pwd-generator">
            <span style="background-color: #f3be38; color: #2e2e2e">Password Generator</span>
        </a>
        <a href="#/moscow-city-tower">
            <span style="background-color: #a3ada5; color: #2e2e2e">Moscow City Tower</span>
        </a>
        <a href="#/chess">
            <span style="background-color: #88ad7b; color: #000000">Chess</span>
        </a>
        <a href="#/lists-compare">
            <span style="background-color: #88ad7b; color: #000000">Lists Compare</span>
        </a>
        <!-- <a href="#/leak-check">
            <span style="background-color: #6c75bd; color: #2e2e2e">Leak Check</span>
        </a> -->
    </div>
</template>

<script>
    export default {
        name: "Main",
        props: {
            arts: Array
        },
    }
</script>

<style scoped>
    .artButtons > a > span {
        background-color: #42b983;
        padding: 13vh 15.4vw;
        display: inline-grid;
        margin: 1px;
    }
    .artButtons > a {
        text-decoration: none;
    }
</style>
